import { observer } from 'mobx-react';
import * as React from 'react';

import { CabinetSplit } from 'shared/entities/cabinet';
import BalanceBase, { BalanceProps } from 'shared/newComponents/Balance';
import { usePaymentStore, usePermissionsStore } from 'stores/index';

type Props = {
  className?: string;
};

const Balance: React.FC<Props> = ({ className }) => {
  const paymentStore = usePaymentStore();
  const permissionsStore = usePermissionsStore();

  const props = React.useMemo((): BalanceProps | null => {
    const info = paymentStore.info;

    if (!info || !permissionsStore.cabinet) {
      return null;
    }

    if (!info.isTrialOver) {
      return {
        state: 'trial',
        daysLeft: info.trialDaysLeft,
        paid: info.billing.balance > 0,
        isElamaUser: permissionsStore.isELamaUser,
        isCorporate: permissionsStore.cabinet.split === CabinetSplit.corporate
      };
    }

    if (info.methods.length > 0) {
      if (info.billing.balance > 0) {
        return {
          state: 'active',
          date: info.nextPaymentDate
        };
      }

      return {
        state: 'inactive'
      };
    }

    if (info.billing.balance > 0) {
      return {
        state: 'suspended',
        daysLeft: info.daysLeft,
        balance: info.roundedBillingBalance
      };
    }

    return {
      state: 'inactive'
    };
  }, [paymentStore.info?.billing]);

  if (!props) {
    return null;
  }

  return <BalanceBase {...props} className={className} />;
};

export default observer(Balance);
